var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTShirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "193 110 110 110",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m233.75 116.11c-14.152 3.0116-21.619 5.7383-26.481 7.7914-8.6 15.138-6.4251 16.52-8.8269 23.745 4.877 6.7703 12.926 7.5403 20.269 9.6465 1.7192-1.5949 2.7409-6.3557 3.5962-11.873-6.8281 24.03-1.2884 47.305-5.5577 65.67 8.2219 3.4075 20.903 5.0934 31.385 4.0812v-86.447c-9.355-2.3821-8.9268-8.4634-14.385-12.615z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.19 116.15c14.152 3.0116 21.619 5.7383 26.481 7.7914 8.6 15.138 6.4251 16.52 8.8269 23.745-4.877 6.7704-12.926 7.5403-20.269 9.6465-1.7192-1.5949-2.7409-6.3557-3.5962-11.873 6.8281 24.03 1.2884 47.305 5.5577 65.67-8.2219 3.4074-20.903 5.0934-31.385 4.0812v-86.447c9.355-2.3821 8.9268-8.4634 14.385-12.615v-8e-6z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.47 147.28c6.3562 3.7049 13.057 7.253 20.694 9.7949l-1.275 2.894c-7.8392-2.0856-14.616-5.3772-20.89-9.2384l1.4712-3.4505z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.53 147.5c-6.3563 3.7049-13.057 7.253-20.694 9.7949l1.275 2.8939c7.8392-2.0856 14.616-5.3773 20.89-9.2384l-1.4712-3.4505z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.48 116.11 2.6481-1.113c11.127 17.725 17.556 10.122 23.538 0.11131l2.55 1.2244c-7.9667 13.766-16.882 20.428-28.737-0.22261z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.44 154.85 8.3343-8.8265-6.3225 3.7343 1.1496-7.4686-3.4487 8.8265-3.736-9.845 4.0234 13.579z",
    fill: "rgba(0,0,0,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.66 154.96-8.3343-8.8265 6.3225 3.7343-1.1496-7.4686 3.4487 8.8265 3.736-9.845-4.0234 13.579z",
    fill: "rgba(0,0,0,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.83 155.4c-2.6209 17.583 0.43864 40.517-2.6481 54.651 3.6831 2.2518 11.195 3.708 15.398 3.8957-12.334 2.4199-10.391-37.538-12.75-58.547z",
    fill: "rgba(0,0,0,0.2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTShirt);
export default __webpack_public_path__ + "static/media/t-shirt.03a71cce0ce431226c5007464561b596.svg";
export { ForwardRef as ReactComponent };